export default __webpack_public_path__ + "static/media/privacy-policy.f78ae2fe.svg";